(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["embed-react"] = factory(require("react"));
	else
		root["embed-react"] = factory(root["react"]);
})(this, (__WEBPACK_EXTERNAL_MODULE_react__) => {
return 